import { useMemo } from "react";
import { useOwnHomeRateBand } from "web_myplann/Inspiration/Hooks/useOwnHomeRateBand";
import {
	computeOwnHomeContext,
	type OwnHomeContext,
	type OwnHomeInputs,
} from "web_myplann/Inspiration/Utils/ownHomeMath";

type Result = {
	context: OwnHomeContext | null;
	isLoading: boolean;
};

export const useOwnHomeContext = (inputs: OwnHomeInputs): Result => {
	const { rates, isLoading } = useOwnHomeRateBand({ rent: inputs.rent });

	const context = useMemo(
		() => (rates ? computeOwnHomeContext(inputs, rates) : null),
		[inputs, rates],
	);

	return { context, isLoading };
};
